import { render, staticRenderFns } from "./ActionBar.vue?vue&type=template&id=436d95fc&scoped=true&"
import script from "./ActionBar.vue?vue&type=script&lang=js&"
export * from "./ActionBar.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_action_bar.scss?vue&type=style&index=0&id=436d95fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d95fc",
  null
  
)

export default component.exports